import { useQuery } from "@tanstack/react-query";
// API
import API from "./Api";

export default function useGetAllDiorSauvageOrdersApi() {
  return useQuery({
    queryKey: ["dior-sauvage-orders"],
    queryFn: async () => {
      const { data } = await API.get("api/get-dior-sauvage-orders");
      return data;
    },
  });
}
